import { post } from '@/api';

export async function studentStep(data: any) {
  return (await post('api/widget/step/student', data)).body.data;
}

export async function complementaryStep(data: any) {
  return (await post('api/widget/step/complementary', data)).body.data;
}

export async function guarantorStep(data: any) {
  return (await post('api/widget/step/guarantor', data)).body.data;
}
